import './style.css';
import 'ol/ol.css';
import 'ol-layerswitcher/src/ol-layerswitcher.css';
import 'ol-ext/control/Search.css';
import {Map, View} from 'ol';
import {Tile as TileLayer, Vector as VectorLayer}  from 'ol/layer';
import TileWMS from 'ol/source/TileWMS';
import {OSM, XYZ} from 'ol/source';
import Feature from 'ol/Feature';
import VectorSource from 'ol/source/Vector';
import {Circle as CircleStyle, Fill, Stroke, Style, Text} from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import GML3 from 'ol/format/GML3';
import {bbox as bboxStrategy} from 'ol/loadingstrategy';
import {transformExtent, transform, fromLonLat} from 'ol/proj.js';
import {Control, defaults as defaultControls, Attribution} from 'ol/control';
import Select from 'ol/interaction/Select';
import Overlay from 'ol/Overlay';
import LayerGroup from 'ol/layer/Group';
import {toStringXY} from 'ol/coordinate';
import SearchBAN from 'ol-ext/control/SearchBAN';
import SearchPhoton from 'ol-ext/control/SearchPhoton';
import LayerSwitcher from 'ol-layerswitcher';
import jquery from "jquery";

window.addEventListener('native.showkeyboard', keyboardShowHandler);
window.addEventListener('native.hidekeyboard', keyboardHideHandler);
window.$ = window.jQuery ; // require('jquery');

var annee = '2021' ;
var clavier= false ;



let openSansAdded = false;
const myDom = {
  pointsEP: {
    text: 'normal', //hide/normal/shorten/wrap
    align: 'left',// center/end/left/right/start
    baseline: 'bottom', // alphabetic/bottom/middle/hanging/ideographic/top
    rotation: 0, //0/0.785398164/1.570796327
    font: "'Open Sans'", //Arial/'Courier New'/'Open Sans'/Verdana
    weight: 'normal', //bold/normal
    size: '10px',
    height: 1, //taille de la ligne
    offsetX: -10,
    offsetY: -10,
    color: 'black',
    outline: 'white',
    outlineWidth: 3,
    maxreso: 30,
  },
  polygonsAAC: {
	 text: 'wrap', //hide/normal/shorten/wrap
    align: 'center',// center/end/left/right/start
    baseline: 'bottom', // alphabetic/bottom/middle/hanging/ideographic/top
    rotation: 0, //0/0.785398164/1.570796327
    font: "'Open Sans'", //Arial/'Courier New'/'Open Sans'/Verdana
    weight: 'normal', //bold/normal
    size: '11px',
    height: 1, //taille de la ligne
    offsetX: -10,
    offsetY: -10,
    color: 'rgba(95, 137, 193, 1.0)',
    outline: 'white',
    outlineWidth: 3,
    maxreso: 50,
    placement: 'point', //line/point
    maxangle: 0.7853981633974483, //0.7853981633974483 pour 45 / 2.0943951023931953 pour 120° / 6.283185307179586 pour 360°
    overflow: 'true', // true/false

  },
};
function keyboardShowHandler() {
	clavier= true ;
}

function keyboardHideHandler() {
	clavier= false ;
}

function checkKBon() {
    if(clavier == true) {
       window.setTimeout(checkKBon, 100); /* on attend et on reteste*/
    } else {
      return true;
    }
}

var attribution = new Attribution({
  collapsible: true
});

var resolutions = [
    156543.03392804103,
    78271.5169640205,
    39135.75848201024,
    19567.879241005125,
    9783.939620502562,
    4891.969810251281,
    2445.9849051256406,
    1222.9924525628203,
    611.4962262814101,
    305.74811314070485,
    152.87405657035254,
    76.43702828517625,
    38.218514142588134,
    19.109257071294063,
    9.554628535647034,
    4.777314267823517,
    2.3886571339117584,
    1.1943285669558792,
    0.5971642834779396,
    0.29858214173896974,
    0.14929107086948493,
    0.07464553543474241
] ;


var vectorSourceEP = new VectorSource({
  format: new GeoJSON(),
  attributions: 'Stations © <a href="http://www.fredon.fr/aura">FREDON-AURA</a> 2021',			
  url: function(extent) {
	  return 'https://www.eauetphyto-aura.fr/geoPHP/indexESO.php?' +
        'bbox=' + transformExtent(extent, 'EPSG:3857','EPSG:4326').join(',') + '&y=' + annee;
  },
  strategy: bboxStrategy
});


//maxfeatures=10000

var rasterOSM = new TileLayer({
	title: 'Routes OpenStreetMap',
	type: 'base',
	visible: true,
	source: new OSM()
});


var rasterEauxSout = new TileLayer({
   	title: 'Eaux souterraines WMS',
	opacity: 0.3,	
    source: new TileWMS({
      url: 'https://services.sandre.eaufrance.fr/geo/MasseDEau_VEDL2019',
      params: {'LAYERS': 'MasseDEauSouterraine_VEDL2019_FXX', 'TILED': true},
      serverType: 'mapserver',
      // Countries have transparency, so do not fade tiles:
      transition: 0,
    })
 })

var rasterCLC  = new TileLayer({
   	title: 'Corine LandeCover 2018 <br/>(themes FREDON AURA)',
	opacity: 1,	
   	visible: false,
	source: new TileWMS({
      attributions: '© <a href="https://xxxxx">Corine Landscape</a>',
		url: 'https://map.fredonra.com/wms',
      params: {'LAYERS': 'CLC18_FR_AURA','TILED': true},
      serverType: 'mapserver',
      // Countries have transparency, so do not fade tiles:
      transition: 10,
    }),
	preload:3
 })


var rasterEntitesHydrogeol  = new TileLayer({
   	title: 'Entités hydrogéologiques <br/>affleurantes - BDLISA',
	opacity: 0.5,	
  	visible: true,
	source: new TileWMS({
      attributions: '© <a href="https://bdlisa.eaufrance.fr/">BDLISA - eaufrance</a>',
		url: 'https://reseau.eaufrance.fr/geotraitements/bdlisa/services/carto/services/carto/',
      params: {'LAYERS': 'ENTITES_O1','STYLES': 'theme', 'TILED': true},
      serverType: 'mapserver',
      // Countries have transparency, so do not fade tiles:
      transition: 0,
	  crossOrigin: 'anonymous',
    })
 })


var topoEsri =  new TileLayer({
	  title: 'ESRI topo',
      type: 'base',
	  opacity: 1.0,	
	  source: new XYZ({
        attributions: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/' +
            'rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
            'World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
		format: "image/png"	
      })
    })





function pointEPStyleFunction(feature, resolution) {
	const freq = feature.get("frequence_totale");
switch (freq) {
   case null:
    return new Style({
		image: new CircleStyle({
		radius: 2,
		fill: new Fill(	 {  color: 'rgba(120, 120,120, 255)'}),
		stroke: new Stroke({color: 'rgba(90, 90,90, 255)', width: 1}),
		}),
		text: createTextStyle(feature, 'Id_Station', resolution, myDom.pointsEP),
	  });
	break;
  case "0":
    return new Style({
		image: new CircleStyle({
		radius: 4,
		fill: new Fill(	 {  color: 'rgba(0, 150, 255, 255)'}),
		stroke: new Stroke({color: 'rgba(0, 20, 255, 150)', width: 1}),
		}),
		text: createTextStyle(feature, 'Id_Station', resolution, myDom.pointsEP),
	  });
	break;
 case "1":
    return new Style({
		image: new CircleStyle({
		radius: 4,
		fill: new Fill(	 {  color: 'rgba(150, 200, 50, 255)'}),
		stroke: new Stroke({color: 'rgba(110, 160, 10, 255)', width: 1}),
		}),
		text: createTextStyle(feature, 'Id_Station', resolution, myDom.pointsEP),
	  });
	break;
 case "2":
    return new Style({
		image: new CircleStyle({
		radius: 4,
		fill: new Fill(	 {  color: 'rgba(255, 200, 0, 255)'}),
		stroke: new Stroke({color: 'rgba(215, 160, 0, 255)', width: 1}),
		}),
		text: createTextStyle(feature, 'Id_Station', resolution, myDom.pointsEP),
	  });
	break;
 case "3":
    return new Style({
		image: new CircleStyle({
		radius: 4,
		fill: new Fill(	 {  color: 'rgba(255, 50, 50, 255)'}),
		stroke: new Stroke({color: 'rgba(190, 0, 0, 255)', width: 1}),
		}),
		text: createTextStyle(feature, 'Id_Station', resolution, myDom.pointsEP),
	  });
	break;
 case "4":
    return new Style({
		image: new CircleStyle({
		radius: 4,
		fill: new Fill(	 {  color: 'rgba(255, 255, 255, 255)'}),
		stroke: new Stroke({color: 'red', width: 1}),
		}),
		text: createTextStyle(feature, 'Id_Station', resolution, myDom.pointsEP),
	  });
	break;
  default:
     return new Style({
    image: new CircleStyle({
      radius: 2,
	fill: new Fill(	 {  color: 'rgba(120, 120,120, 255)'}),
	stroke: new Stroke({color: 'rgba(90, 90,90, 255)', width: 1}),
    }),
    text: createTextStyle(feature, 'Id_Station', resolution, myDom.pointsEP),
  });
}

}


function polygonAACStyleFunction(feature, resolution) {
  return new Style({
    stroke: new Stroke({
    	color: 'rgba(95, 137, 193, 1)',
    	width: 1.5
  	}),
   fill: new Fill({
    color: 'rgba(125, 180, 255, .3)'
  }),
    text: createTextStyle(feature, 'NomDeAAC_Administratif',resolution, myDom.polygonsAAC), //CdAAC
  });
}





var pointsEP = new VectorLayer({
	  maxResolution: 500,
	  title: 'Stations Eau et phyto',	
      source: vectorSourceEP,
      style: pointEPStyleFunction
	
    })

var vectorSourceAAC = new VectorSource({
  format: new GML3(),
  //format: new GML3(),
  attributions: 'Aires d\'alimentations de captage - Métropole © <a href="https://services.sandre.eaufrance.fr">SANDRE</a> 2022',	
  url: function(extent) {
    return 'https://services.sandre.eaufrance.fr/geo/sandre?service=WFS&' +
        'version=1.1.0&outputFormat=GML3&request=GetFeature&typename=sa:AAC_FXX&' +
        'srsname=EPSG:3857&' +
        'bbox=' + extent.join(',') + ',EPSG:3857';
  },
   strategy: bboxStrategy
});

var vectorAAC = new VectorLayer({
	maxResolution: 2000,
	  title: 'Aires alimentation de captage',								   
	  source: vectorSourceAAC,
  	style: polygonAACStyleFunction,
	//  declutter: true,
});

//description des etiquettes des Points de stations!!!!

document.addEventListener('DOMContentLoaded',function() {
		if (typeof centrer_sur != 'undefined') {
			var centre_coord=centrer_sur.split(",");
		var centre = fromLonLat([centre_coord[0],centre_coord[1]]);
		}

		view.animate({
				center: centre,
				duration: 500
		  });
		}
		, false);


var zoom = 15;
var center = transform([4.966071,45.714023 ], 'EPSG:4326', 'EPSG:3857');
var rotation = 0;


if (window.location.hash !== '') {
  // try to restore center, zoom-level and rotation from the URL
  var hash = window.location.hash.replace('#map=', '');
  var parts = hash.split('/');
  if (parts.length === 4) {
    zoom = parseInt(parts[0], 10);
    center = [
      parseFloat(parts[1]),
      parseFloat(parts[2])
    ];
    rotation = parseFloat(parts[3]);
  }
}


var container = document.getElementById('popup');
var content = document.getElementById('popup-content');
var closer = document.getElementById('popup-closer');


var overlay = new Overlay({
  element: container,
  autoPan: true,
  autoPanAnimation: {
    duration: 250
  }
});

closer.onclick = function() {
  overlay.setPosition(undefined);
  closer.blur();
  return false;
};

var view = new View({
  center: center,
  zoom: zoom,
  rotation
});

const map = new Map({
  target: 'map',
  layers: [ rasterOSM ,topoEsri, 
			 new LayerGroup({
                  title: 'couches metiers', // A layer must have a title to appear in the layerswitcher
                 // Setting the layers type to 'base' results
                        // in it having a radio button and only one
                        // base layer being visibile at a time
                        //type: 'base',
                        // Setting combine to true causes sub-layers to be hidden
                        // in the layerswitcher, only the parent is shown
                        //combine: true,
				// Adding a 'fold' property set to either 'open' or 'close' makes the group layer
                // collapsible
                fold: 'open',
                layers: [ rasterEntitesHydrogeol, rasterCLC,vectorAAC]
            }), pointsEP
        ],
  overlays: [overlay],			
  controls: defaultControls({attribution: false}).extend([attribution]),
  view: view
  
});

var layerSwitcher = new LayerSwitcher({
    startActive: true,
	activationMode: 'click'});
map.addControl(layerSwitcher);


var ok_button = document.getElementById('ok_button');
var annees = document.getElementById('annees');


document
  .getElementById('annees')
  .addEventListener('change', function () {
    change_annee_etude(map.getView().calculateExtent(map.getSize()));
  });
  

													   

 
 
 function change_annee_etude(extent) {
		annee=annees.value;
		vectorSourceEP.clear();
		vectorSourceEP.refresh();
		//var url = 'https://www.eauetphyto-aura.fr/geoPHP/index.php?' + 'bbox=' + transformExtent(extent, 'EPSG:3857','EPSG:4326').join(',') + '&y=' + annees.value;
		//vectorSourcePrunus.setUrl(url);
		

		
}
const search = new SearchBAN({
	label : 'Localisation d\'adresse',
	placeholder : 'Adresse...',
    reverse:true,
    position: true	// Search, with priority to geo position
  });
map.addControl (search);

search.on('select', function (e) {
	window.setTimeout(function(){ //sur les mobiles, permet d'attendre que le clavier virtuel se barre  (car il redimensionne la carte et postionne la recherche à l'arrache du coup
					  
			map.getView().animate({
			  center:e.coordinate,
			  zoom: Math.max (map.getView().getZoom(),16)
			});
	}, 500);
});
	
	function checkSize() {
  var small = map.getSize()[0] < 2000;
  attribution.setCollapsible(small);
  attribution.setCollapsed(small);
}

window.addEventListener('resize', checkSize);
checkSize();


var featureOverlay = new VectorLayer({
  source: new VectorSource(),
  map: map,
  style: new Style({
    stroke: new Stroke({
      color: '#f00',
      width: 1
    }),
    fill: new Fill({
      color: 'rgba(255,0,0,0.1)'
    })
  })
});

var highlight;

/*map.on('singleclick', function (evt) {
   	coord.innerHTML = 'coord :' + toStringXY(transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326'),5);
});*/


var shouldUpdate = true;
var view = map.getView();
var updatePermalink = function() {
  if (!shouldUpdate) {
    // do not update the URL when the view was changed in the 'popstate' handler
    shouldUpdate = true;
    return;
  }

  var center = view.getCenter();
  var hash = "#map=" +     view.getZoom() + '\/' +  Math.round(center[0] * 100) / 100 + "\/" + Math.round(center[1] * 100) / 100 + '\/' +     view.getRotation();
  
  var state = {
    zoom: view.getZoom(),
    center: view.getCenter(),
    rotation: view.getRotation()
  };
  window.history.pushState(state, 'map', hash);
  document.getElementById('permalien').setAttribute('href', hash);
};

map.on('moveend', updatePermalink);
// restore the view state when navigating through the history, see
// https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
window.addEventListener('popstate', function(event) {
  if (event.state === null) {
    return;
  }
  map.getView().setCenter(event.state.center);
  map.getView().setZoom(event.state.zoom);
  map.getView().setRotation(event.state.rotation);
  shouldUpdate = false;
});

function handler(request) {
    // if the response was XML, try the parsed doc
    alert(request.responseXML);
    // otherwise, you've got the response text
    alert(request.responseText);
    // and don't forget you've got status codes
    alert(request.status);
    // and of course you can get headers
    alert(request.getAllResponseHeaders());
    // etc.
}



var displayFeatureInfo = function(pixel,coordinate) {
 

 
var info = document.getElementById('info');
var lacouche = "";
var feature = map.forEachFeatureAtPixel(pixel, function(feature,layer) {
		 var layer = feature.getLayer(map);
		lacouche = layer.get('title');
    	return feature;
});

  if (feature) { //on teste si on a des objects vecteurs sous le click
	  if (lacouche=="Stations Eau et phyto") {
		  var s='{"<p style=\'background:#000\'><b  style=\'color:#FFF\'>STATION DE PRELEVEMENT</b></p>":"","<b>Id_Station</b>":"<a href=\'https://www.eauetphyto-aura.fr/graph-resultats-analyses-ESO/?id='+feature.get('Id_Station')+'&y='+annee+'\' target=\'_blank\'>' + feature.get('Id_Station')+'</a>","<b>Ancien code</b>":"' + feature.get('Ancien_code')+'","<b>Commune</b>":"'+ feature.get('INSEE_Commune')+' - '+ feature.get('Commune')+'", "<b>XGPS</b>":"' + feature.get('XGPS')+'", "<b>YGPS</b>":"' + feature.get('YGPS') + '"}'; 
		  //+'", "frequence_totale ":"' + (feature.get('frequence_totale') === null ? "pas d'analyse en " + annee  : feature.get('frequence_totale')) +
				  //(feature.get('frequence_totale') === null ? "pas d'analyse en "   : feature.get('frequence_totale'))
		var objs = JSON.parse(s);	  
		content.innerHTML = obj2htmltable(objs) ;
		overlay.setPosition(coordinate);
	  } else if (lacouche=="Aires alimentation de captage") {
		  		  var s='{"<p style=\'background:#000\'><b  style=\'color:#FFF\'>AIRE ALIMENTATION DE CAPTAGE</b></p>":"","<b>Id_AAC</b>":"<a href=\'https://aires-captages.fr/aires-alimentation-captages/cdSandre/'+feature.get('CdAAC')+'\' target=\'_blank\'>' + feature.get('CdAAC')+'</a>","<b>Nom</b>":"' + feature.get('NomDeAAC_Administratif')+'", "<b>Auteur</b>":"' + feature.get('AuteurAAC')+'","<b>Bassin</b>":"'+ feature.get('NomCircAdminBassin') + '"}'; 
		  //+'", "frequence_totale ":"' + (feature.get('frequence_totale') === null ? "pas d'analyse en " + annee  : feature.get('frequence_totale')) +
				  //(feature.get('frequence_totale') === null ? "pas d'analyse en "   : feature.get('frequence_totale'))
		var objs = JSON.parse(s);	  
		content.innerHTML = obj2htmltable(objs) ;
		overlay.setPosition(coordinate);
	  }
	
	  
  } else { // dans les cas où l'on n'est pas tombé sur une station, c'est ici qu'on insert le code pour afficher les infos sur BLISA si jamais elle est affiché
  		console.log("pas d'obj vecto");
  		info.innerHTML = '&nbsp;';
		const viewResolution = /** @type {number} */ (view.getResolution());
		
		if (rasterEntitesHydrogeol.rendered==true && rasterEntitesHydrogeol.getData(pixel).toString()!='0,0,0,0') {
		
				   const url = rasterEntitesHydrogeol.getSource().getFeatureInfoUrl(coordinate,viewResolution,'EPSG:3857',{'INFO_FORMAT': 'application/vnd.ogc.gml'} );
				   
				  if (url) {
					fetch(url)
					  .then((response) => response.text())
					  .then((html) => {
						var xml = html,
									xmlDoc = $.parseXML(xml),
									$xml = $(xmlDoc),
									$fiche_nationale = $xml.find("fiche_nationale"),
									$denomination= $xml.find("denomination"),
									$etat = $xml.find("etat"),
									$nature = $xml.find("nature"),
									$milieu = $xml.find("milieu"),
									$theme = $xml.find("theme"),
									$entite = $xml.find("entite");
												
								 var s='{"<p style=\'background:#000\'><b  style=\'color:#FFF\'>ENTITE HYDROGEOLOGIQUE</b></p>":"","<b>entité</b>":"<a href=\''+ $fiche_nationale.text() +'\' target=\'_blank\'>' + $entite.text()+'</a>","<b>denomination</b>":"' + $denomination.text()+'","<b>etat</b>":"'
								 + $etat.text()+'", "<b>theme</b>":"' + $theme.text()+'", "<b>nature</b>":"' + $nature.text() + '"}'; 
								 
								 var objs = JSON.parse(s);	  
								content.innerHTML = obj2htmltable(objs) ;
								overlay.setPosition(coordinate);
					  });
				  }
		}
	
	
  }
	//on desactive la mise en surbrillance du polygone selectionné
  /*if (feature !== highlight) {
    if (highlight) {
      featureOverlay.getSource().removeFeature(highlight);
    }
    if (feature) {
      featureOverlay.getSource().addFeature(feature);
    }
    highlight = feature;
  }*/

};

map.on('click', function(evt) {
	displayFeatureInfo(evt.pixel,evt.coordinate);
	//rasterEntitesHydrogeol.getdata(evt.pixel);
	//const data = rasterEntitesHydrogeol.getData();
	//console.log(data);
});
map.on('pointermove', function (evt) {
  if (evt.dragging) {
    return;
  }
  const data = rasterEntitesHydrogeol.getData(evt.pixel);
  const hit = data && data[3] > 0; // transparent pixels have zero for data[3]
  map.getTargetElement().style.cursor = hit ? 'pointer' : '';
});

Feature.prototype.getLayer = function(map) {
    var this_ = this, layer_, layersToLookFor = [];
    /**
     * Populates array layersToLookFor with only
     * layers that have features
     */
    var check = function(layer){
        var source = layer.getSource();
        if(source instanceof VectorSource){
            var features = source.getFeatures();
            if(features.length > 0){
            	layersToLookFor.push({
                	layer: layer,
                    features: features
                });
            }
        }
    };
    //loop through map layers
    map.getLayers().forEach(function(layer){
        if (layer instanceof LayerGroup) {
            layer.getLayers().forEach(check);
        } else {
			check(layer);
        }
    });
    layersToLookFor.forEach(function(obj){
        var found = obj.features.some(function(feature){
            return this_ === feature;
        });
        if(found){
            //this is the layer we want
            layer_ = obj.layer;
        }
    });
    return layer_;
};



String.prototype.format = function()
{
  var args = arguments;
  return this.replace(/{(\d+)}/g, function(match, number)
  {
    return typeof args[number] != 'undefined' ? args[number] :
                                                '{' + number + '}';
  });
};



/**
 * Convert a Javascript Oject array or String array to an HTML table
 * JSON parsing has to be made before function call
 * It allows use of other JSON parsing methods like jQuery.parseJSON
 * http(s)://, ftp://, file:// and javascript:; links are automatically computed
 *
 * JSON data samples that should be parsed and then can be converted to an HTML table
 *     var objectArray = '[{"Total":"34","Version":"1.0.4","Office":"New York"},{"Total":"67","Version":"1.1.0","Office":"Paris"}]';
 *     var stringArray = '["New York","Berlin","Paris","Marrakech","Moscow"]';
 *     var nestedTable = '[{ key1: "val1", key2: "val2", key3: { tableId: "tblIdNested1", tableClassName: "clsNested", linkText: "Download", data: [{ subkey1: "subval1", subkey2: "subval2", subkey3: "subval3" }] } }]'; 
 *
 * Code sample to create a HTML table Javascript String
 *     var jsonHtmlTable = ConvertJsonToTable(eval(dataString), 'jsonTable', null, 'Download');
 *
 * Code sample explaned
 *  - eval is used to parse a JSON dataString
 *  - table HTML id attribute will be 'jsonTable'
 *  - table HTML class attribute will not be added
 *  - 'Download' text will be aylayed instead of the link itself
 *
 * @author Afshin Mehrabani <afshin dot meh at gmail dot com>
 * 
 * @class ConvertJsonToTable
 * 
 * @method ConvertJsonToTable
 * 
 * @param parsedJson object Parsed JSON data
 * @param tableId string Optional table id 

 * @param tableClassName string Optional table css class name
 * @param linkText string Optional text replacement for link pattern
 *  
 * @return string Converted JSON to HTML table
 */
function ConvertJsonToTable(parsedJson, tableId, tableClassName, linkText)
{
    //Patterns for links and NULL value
    var italic = '<i>{0}</i>';
    var link = linkText ? '<a href="{0}">' + linkText + '</a>' :
                          '<a href="{0}">{0}</a>';

    //Pattern for table                          
    var idMarkup = tableId ? ' id="' + tableId + '"' :
                             '';

    var classMarkup = tableClassName ? ' class="' + tableClassName + '"' :
                                       '';

    var tbl = '<table border="1" cellpadding="1" cellspacing="1"' + idMarkup + classMarkup + '>{0}{1}</table>';

    //Patterns for table content
    var th = '<thead>{0}</thead>';
    var tb = '<tbody>{0}</tbody>';
    var tr = '<tr>{0}</tr>';
    var thRow = '<th>{0}</th>';
    var tdRow = '<td>{0}</td>';
    var thCon = '';
    var tbCon = '';
    var trCon = '';

    if (parsedJson)
    {
        var isStringArray = typeof(parsedJson[0]) == 'string';
        var headers;

        // Create table headers from JSON data
        // If JSON data is a simple string array we create a single table header
        if(isStringArray)
            thCon += thRow.format('value');
        else
        {
            // If JSON data is an object array, headers are automatically computed
            if(typeof(parsedJson[0]) == 'object')
            {
                headers = array_keys(parsedJson[0]);

                for (var i = 0; i < headers.length; i++)
                    thCon += thRow.format(headers[i]);
            }
        }
        th = th.format(tr.format(thCon));
        
        // Create table rows from Json data
        if(isStringArray)
        {
            for (var i = 0; i < parsedJson.length; i++)
            {
                tbCon += tdRow.format(parsedJson[i]);
                trCon += tr.format(tbCon);
                tbCon = '';
            }
        }
        else
        {
            if(headers)
            {
                var urlRegExp = new RegExp(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);
                var javascriptRegExp = new RegExp(/(^javascript:[\s\S]*;$)/ig);
                
                for (var i = 0; i < parsedJson.length; i++)
                {
                    for (var j = 0; j < headers.length; j++)
                    {
                        var value = parsedJson[i][headers[j]];
                        var isUrl = urlRegExp.test(value) || javascriptRegExp.test(value);

                        if(isUrl)   // If value is URL we auto-create a link
                            tbCon += tdRow.format(link.format(value));
                        else
                        {
                            if(value){
                            	if(typeof(value) == 'object'){
                            		//for supporting nested tables
                            		tbCon += tdRow.format(ConvertJsonToTable(eval(value.data), value.tableId, value.tableClassName, value.linkText));
                            	} else {
                            		tbCon += tdRow.format(value);
                            	}
                                
                            } else {    // If value == null we format it like PhpMyAdmin NULL values
                                tbCon += tdRow.format(italic.format(value).toUpperCase());
                            }
                        }
                    }
                    trCon += tr.format(tbCon);
                    tbCon = '';
                }
            }
        }
        tb = tb.format(trCon);
        tbl = tbl.format(th, tb);

        return tbl;
    }
    return null;
}


/**
 * Return just the keys from the input array, optionally only for the specified search_value
 * version: 1109.2015
 *  discuss at: http://phpjs.org/functions/array_keys
 *  +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
 *  +      input by: Brett Zamir (http://brett-zamir.me)
 *  +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
 *  +   improved by: jd
 *  +   improved by: Brett Zamir (http://brett-zamir.me)
 *  +   input by: P
 *  +   bugfixed by: Brett Zamir (http://brett-zamir.me)
 *  *     example 1: array_keys( {firstname: 'Kevin', surname: 'van Zonneveld'} );
 *  *     returns 1: {0: 'firstname', 1: 'surname'}
 */
function array_keys(input, search_value, argStrict)
{
    var search = typeof search_value !== 'undefined', tmp_arr = [], strict = !!argStrict, include = true, key = '';

    if (input && typeof input === 'object' && input.change_key_case) { // Duck-type check for our own array()-created PHPJS_Array
        return input.keys(search_value, argStrict);
    }
 
    for (key in input)
    {
        if (input.hasOwnProperty(key))
        {
            include = true;
            if (search)
            {
                if (strict && input[key] !== search_value)
                    include = false;
                else if (input[key] != search_value)
                    include = false;
            } 
            if (include)
                tmp_arr[tmp_arr.length] = key;
        }
    }
    return tmp_arr;
}

function obj2htmltable(obj) {
    var html = '<table>';
    for (var key in obj) {
        var item = obj[key];
        var value = (typeof(item) === 'object') ? obj2htmltable(item) : item.toString();
        html += '<tr><td>' + key + '</td><td>' + value + '</tr>';
    }
    html += '</table>';
    return html;
}


String.prototype.trunc =
  String.prototype.trunc ||
  function (n) {
    return this.length > n ? this.substr(0, n - 1) + '...' : this.substr(0);
  };

// https://stackoverflow.com/questions/14484787/wrap-text-in-javascript
function stringDivider(str, width, spaceReplacer) {
  if (str.length > width) {
    let p = width;
    while (p > 0 && str[p] != ' ' && str[p] != '-') {
      p--;
    }
    if (p > 0) {
      let left;
      if (str.substring(p, p + 1) == '-') {
        left = str.substring(0, p + 1);
      } else {
        left = str.substring(0, p);
      }
      const right = str.substring(p + 1);
      return left + spaceReplacer + stringDivider(right, width, spaceReplacer);
    }
  }
  return str;
}

const getText = function (feature, labelField, resolution, dom) {
  const type = dom.text;
  const maxResolution = dom.maxreso;
  let text = feature.get(labelField);

  if (resolution > maxResolution) {
    text = '';
  } else if (type == 'hide') {
    text = '';
  } else if (type == 'shorten') {
    text = text.trunc(20);
  } else if (
    type == 'wrap' &&
    (!dom.placement || dom.placement.value != 'line')
  ) {
    text = stringDivider(text, 30, '\n');
  }

  return text;
};

const createTextStyle = function (feature, labelField, resolution, dom) {
  const align = dom.align;
  const baseline = dom.baseline.value;
  const size = dom.size;
  const height = dom.height;
  const offsetX = parseInt(dom.offsetX, 10);
  const offsetY = parseInt(dom.offsetY, 10);
  const weight = dom.weight;
  const placement = dom.placement ? dom.placement : undefined;

  const maxAngle = dom.maxangle ? parseFloat(dom.maxangle) : undefined;
  const overflow = dom.overflow ? dom.overflow == 'true' : undefined;
  const rotation = parseFloat(dom.rotation);
  if (dom.font == "'Open Sans'" && !openSansAdded) {
    const openSans = document.createElement('link');
    openSans.href = 'https://fonts.googleapis.com/css?family=Open+Sans';
    openSans.rel = 'stylesheet';
    document.head.appendChild(openSans);
    openSansAdded = true;
  }
  const font = weight + ' ' + size + '/' + height + ' ' + dom.font;
  const fillColor = dom.color;
  const outlineColor = dom.outline;
  const outlineWidth = parseInt(dom.outlineWidth, 10);

  return new Text({
    textAlign: align == '' ? undefined : align,
    textBaseline: baseline,
    font: font,
    text: getText(feature, labelField, resolution, dom),
    fill: new Fill({color: fillColor}),
    stroke: new Stroke({color: outlineColor, width: outlineWidth}),
    offsetX: offsetX,
    offsetY: offsetY,
    placement: placement,
    maxAngle: maxAngle,
    overflow: overflow,
    rotation: rotation,
  });
};